module.exports = __webpack_public_path__ + "static/img/ic_about_logo.27267b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_about_logo.png
// module id = B1BI
// module chunks = 0